var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUpWhiteArrow(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 11,
    viewBox: "0 0 17 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.5578 9.56011C16.1658 8.92011 16.1658 7.92811 15.5578 7.32011C13.2218 4.95211 9.38175 0.888113 9.31775 0.824113C8.99775 0.504113 8.58175 0.344113 8.16575 0.344113C7.78175 0.344113 7.36575 0.504113 7.04575 0.824113C6.98175 0.888113 2.88575 4.88811 0.549751 7.25611C-0.0582502 7.86411 -0.0582502 8.85611 0.549751 9.49611C1.15775 10.1041 2.18175 10.1041 2.78975 9.49611L8.16575 4.18411L13.3178 9.56011C13.9258 10.1681 14.9498 10.1681 15.5578 9.56011Z",
    fill: "#F8F8F8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpWhiteArrow);
export default __webpack_public_path__ + "static/media/up_white_arrow.f4675618ddffdbce7728105b97ce720d.svg";
export { ForwardRef as ReactComponent };